var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataScience({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M9.593 4.472c.058.02.144.037.203.048.257.05.737.142.812.714.003.02.004.04.004.06l-.048 4.339a.403.403 0 0 1-.05.19 185.98 185.98 0 0 1-5.45 9.319c-.013.02-.402.614-.175 1.026.212.385.949.596 2.073.596h10.012c1.127 0 1.865-.212 2.075-.598.223-.412-.163-1.002-.167-1.008a185.963 185.963 0 0 1-5.465-9.334.413.413 0 0 1-.05-.191c-.015-1.447-.03-2.894-.047-4.34 0-.02.001-.04.003-.059.075-.572.555-.664.813-.714.058-.011.144-.028.202-.047.025-.111.04-.253.05-.39H9.543c.01.139.025.28.05.39M6.933 21.56c-1.498 0-2.444-.338-2.804-1.004-.445-.827.205-1.773.23-1.813a187.286 187.286 0 0 0 5.426-9.213l.071-4.176c-.046-.02-.142-.038-.208-.05-.2-.039-.449-.086-.64-.282a.387.387 0 0 1-.084-.135c-.152-.411-.137-1.124-.135-1.204.006-.22.176-.399.38-.399h5.59c.206 0 .376.179.382.399.002.08.016.793-.136 1.204a.378.378 0 0 1-.084.134c-.19.197-.44.244-.64.283-.066.012-.161.03-.208.05l.072 4.176a186.978 186.978 0 0 0 5.44 9.23c.016.023.665.97.22 1.796-.36.666-1.306 1.004-2.803 1.004H6.933z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.918 11.97h6.05l4.407 7.283v1.351l-1.036.485H5.68l-1.458-.904 1.244-2.423 2.95-4.814z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScience);
export default __webpack_public_path__ + "static/media/data-science.0de115ed.svg";
export { ForwardRef as ReactComponent };